export const FACILITY_EMISSION_RECORD_LIST_PAGE_TITLE = "Emissions Records";

export const linkToFacilityEmissionRecordList = (facilityId = ":facilityId") =>
  `/app/organization/facilities/${facilityId}/detail?tab=emissions`;

export const FACILITY_EMISSION_RECORD_LIST_BREADCRUMB = {
  title: FACILITY_EMISSION_RECORD_LIST_PAGE_TITLE,
  path: linkToFacilityEmissionRecordList(),
};
